import axios from 'axios';

export function index(query) {
  return new Promise(resolve => {
    axios.get('/admin/options/jobs', { params: query }).then(({ data }) => {
      resolve(data);
    });
  });
}

export function show(id) {
  return new Promise(resolve => {
    axios.get(`/admin/options/jobs/${id}`).then(({ data }) => {
      resolve(data);
    });
  });
}
